import { z } from "zod";

// org/slug params used by the forms route
export const orgSlugParamsSchema = z.object({
	org: z
		.string()
		.min(1)
		.max(64)
		.regex(/^[a-z0-9-]+$/i),
	slug: z
		.string()
		.min(1)
		.max(128)
		.regex(/^[a-z0-9-]+$/i),
});

export type OrgSlugParams = z.infer<typeof orgSlugParamsSchema>;
